import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
const getInitialState = () => ({
    field: null,
    index: undefined
});
export const useSelectedFieldStore = create()(devtools((set, get) => (Object.assign(Object.assign({}, getInitialState()), { selectField: (field, index) => set({ field, index }), isFieldSelected: () => !!get().field, reset: () => set(getInitialState()) }))));
